<template>
  <div>
    <TitleWrapper
      :filter-option="false"
      title="SUPPORT_QUERY"
      tooltip-title="SUPPORT_QUERY_TYPE"
      :display-breadcrumb="true"
    ></TitleWrapper>
    <template v-if="isLoading"><Loader class="mt-20 mb-40" :content="true" /></template>
    <div v-else-if="!isLoading && isEmpty(supportQueries)">
      <NoRecordFound />
    </div>
    <TableWrapper v-else>
      <THead>
        <TRHead>
          <TH
            v-for="head in tableHeaders.filter((head) => !head.skipForDataTableHead)"
            v-show="showColumnInDataTable(filtersData, head.dataTableName, skipForFilterColumns)"
            :key="head.id"
          >
            {{ head.dataTableName }}
          </TH>
        </TRHead>
      </THead>
      <TBody>
        <TRBody v-for="(query, index) in supportQueries" :key="index">
          <TD v-show="showColumnInDataTable(filtersData, 'Title', ['Title'])">
            <span
              class="text-primary-purple-600 cursor-pointer"
              @click="redirectToSupportQueryConversationPage(query.id, query.status)"
            >
              {{ query.title || GENERAL_CONSTANTS.NOT_APPLICABLE }}
            </span>
          </TD>
          <TD v-show="showColumnInDataTable(filtersData, 'Student', ['Student'])">
            {{ query?.student?.full_name || GENERAL_CONSTANTS.NOT_APPLICABLE }}
          </TD>
          <TD
            v-show="
              showColumnInDataTable(filtersData, 'Query Initiated at', ['Query Initiated at'])
            "
          >
            {{
              $filters.formattedDate(query?.inserted_at, DATE_TIME_CONSTANT.DATE_TIME_12) ||
              GENERAL_CONSTANTS.NOT_APPLICABLE
            }}
          </TD>
          <TD v-show="showColumnInDataTable(filtersData, 'Query Closed at', ['Query Closed at'])">
            {{
              $filters.formattedDate(query?.last_activity, DATE_TIME_CONSTANT.DATE_TIME_12) ||
              GENERAL_CONSTANTS.NOT_APPLICABLE
            }}
          </TD>
          <TD v-show="showColumnInDataTable(filtersData, 'Status', ['Status'])">
            {{ query?.status || GENERAL_CONSTANTS.NOT_APPLICABLE }}
          </TD>

          <TD v-show="showColumnInDataTable(filtersData, 'Actions', ['Actions'])">
            <TableAction
              :idx="index"
              :current-user="query"
              :action-list="query.actionList"
              @action="typeAction"
            />
          </TD>
        </TRBody>
      </TBody>
    </TableWrapper>
    <Pagination
      v-if="supportQueryCounts > GENERAL_CONSTANTS.RECORD_LIMIT"
      v-show="!isLoading"
      :key="`Pagination${forceRender}`"
      :record-limit="GENERAL_CONSTANTS.RECORD_LIMIT"
      :max-range="paginationCounts(supportQueryCounts, GENERAL_CONSTANTS.RECORD_LIMIT)"
      @filterRecord="getSupportQueriesList"
    />
    <SupportQueryModal
      v-if="isModalShow"
      :modal="isModalShow"
      :edit="currentSupportQuery"
      @toggle="toggleSupportQueryModal"
    />
    <!-- Modal to delete support query -->

    <UIConfirmationModal
      v-if="deleteModelShow"
      :modal="deleteModelShow"
      heading="DELETE_SUPPORT_QUERY"
      message="Are you sure you want to delete "
      button-text="Delete"
      :name="currentSupportQuery.title"
      remaining-message="Support Query?"
      @cancel="toggleDeleteModel"
      @confirm="deleteSupportQueryById"
    />
    <!-- Modal to closed support query -->
    <UIConfirmationModal
      v-if="closeSupportQueryModelShow"
      :modal="closeSupportQueryModelShow"
      heading="CLOSE_SUPPORT_QUERY"
      message="Are you sure you want to close "
      button-text="Close"
      :name="currentSupportQuery.title"
      remaining-message="Support Query?"
      @cancel="toggleCloseSupportQueryModel"
      @confirm="closeCurrentSupportQuery"
    />
    <!-- Modal to reopen support query -->

    <UIConfirmationModal
      v-if="toggleReOpenSupportQueryModel"
      :modal="toggleReOpenSupportQueryModel"
      heading="REOPEN_SUPPORT_QUERY"
      message="Are you sure you want to reopen "
      button-text="Reopen"
      :name="currentSupportQuery.title"
      remaining-message="Support Query?"
      @cancel="toggleReOpenSupportQueryModelShow"
      @confirm="reOpenCurrentSupportQuery"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TableAction from '@components/TableAction.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import { showColumnInDataTable } from '@utils/generalUtil'
import { paginationRangeHandler } from '@src/components/BaseComponent/pagination.util.js'
import Pagination from '@components/BaseComponent/Pagination.vue'
import isEmpty from 'lodash/isEmpty'
import scrollMixin from '@src/mixins/scroll-mixin'
import NoRecordFound from '@components/BaseComponent/NoRecordFound.vue'
import SupportQueryModal from '@/src/router/views/admin/modals/AddAndEditSupportQueryModal.vue'
import { paginationCounts } from '@src/components/BaseComponent/pagination.util.js'
import UIConfirmationModal from '@src/components/UiElements/UIConfirmationModal.vue'
import generalMixin from '@src/mixins/general-mixins.js'
import GENERAL_CONSTANTS from '@src/constants/general-constants.js'
import supportQueryData from '@src/router/views/support-query/support-query/supportQueryData.json'
import fileMixin from '@src/mixins/file-mixins'
import TitleWrapper from '@/src/components/TitleWrapper.vue'
import DATE_TIME_CONSTANT from '@src/constants/date-time-constants.js'

import {
  TableWrapper,
  TBody,
  TD,
  TH,
  THead,
  TRBody,
  TRHead,
} from '@src/components/UiElements/TableElements/index.js'
export default {
  name: 'SupportQuery',
  components: {
    TitleWrapper,
    TableAction,
    Loader,
    Pagination,
    UIConfirmationModal,
    NoRecordFound,
    SupportQueryModal,
    TableWrapper,
    TBody,
    TD,
    TH,
    THead,
    TRBody,
    TRHead,
  },
  mixins: [fileMixin, scrollMixin, generalMixin],
  data() {
    return {
      DATE_TIME_CONSTANT,
      GENERAL_CONSTANTS,
      isLoading: false,
      filtersData: {},
      dashboard: 'dashboard',
      deleteModelShow: false,
      supportQueries: [],
      actionList: supportQueryData.actionList,
      defaultSelectedColumns: supportQueryData.defaultSelectedColumns,
      tableHeaders: supportQueryData.tableHeaders,
      skipForFilterColumns: supportQueryData.defaultSelectedColumns,
      supportQueryCounts: GENERAL_CONSTANTS.EMPTY_RECORD,
      currentSupportQuery: null,
      isModalShow: false,
      closeSupportQueryModelShow: false,
      toggleReOpenSupportQueryModel: false,
      forceRender: 0,
    }
  },
  computed: {
    ...mapState({
      currentCampusScope: (state) => state.layout.currentCampusScope,
    }),
  },
  watch: {
    currentCampusScope: {
      handler() {
        this.getSupportQueriesList()
      },
    },
  },

  mounted() {
    this.setRightbarData()
    this.getSupportQueriesList()
    this.initializeSupportQuerySocket()
  },
  methods: {
    showColumnInDataTable,
    isEmpty,
    paginationCounts,

    initializeSupportQuerySocket() {
      if (!this.$apiSocketChannel?.channels?.length) {
        const authToken = localStorage.getItem('jwt') || null
        this.$connectApiSocket('/tenant-api-socket', authToken)
      }
    },
    async getSupportQueriesList(range) {
      this.isLoading = true
      const paginationLimit = paginationRangeHandler(range)
      const payload = { ...paginationLimit }
      try {
        const res = await this.getsupportQueries(payload) // Expect a single response
        this.supportQueries = res[0]?.data?.records || []
        this.supportQueryCounts = res[0]?.data?.meta?.total_records || 0

        this.supportQueries.forEach(
          (query) => (query['actionList'] = this.getActionsList(query.status)),
        )

        this.setRightbarData(this.supportQueryCounts)
      } finally {
        this.isLoading = false
      }
    },

    getActionsList(status) {
      let actions = [{ name: 'Edit' }, { name: 'Delete' }]

      status === 'closed' ? actions.unshift({ name: 'REOPEN' }) : actions.unshift({ name: 'CLOSE' })
      return actions
    },

    toggleSupportQueryModal(payload) {
      this.isModalShow = !this.isModalShow
      if (!this.isModalShow) this.currentSupportQuery = null
      if (payload) {
        this.getSupportQueriesList()
        this.forceRender++
      }
    },

    async deleteSupportQueryById() {
      await this.deleteSupportQuery(this.currentSupportQuery?.id)
      this.toggleDeleteModel()
      this.getSupportQueriesList()
      this.forceRender++
    },

    async closeCurrentSupportQuery() {
      await this.closeSupportQuery(this.currentSupportQuery?.id)
      this.toggleCloseSupportQueryModel()
      this.getSupportQueriesList()
    },

    async reOpenCurrentSupportQuery() {
      await this.reOpenSupportQuery(this.currentSupportQuery?.id)
      this.toggleReOpenSupportQueryModelShow()
      this.getSupportQueriesList()
    },

    toggleDeleteModel() {
      this.deleteModelShow = !this.deleteModelShow
      if (!this.deleteModelShow) this.currentSupportQuery = null
    },

    toggleCloseSupportQueryModel() {
      this.closeSupportQueryModelShow = !this.closeSupportQueryModelShow
    },

    toggleReOpenSupportQueryModelShow() {
      this.toggleReOpenSupportQueryModel = !this.toggleReOpenSupportQueryModel
    },
    redirectToSupportQueryConversationPage(id, status) {
      this.$router?.push({
        name: 'support-query-conversation',
        params: { id },
        query: { status },
      })
    },

    typeAction(action, currentType) {
      this.currentSupportQuery = currentType
      switch (action) {
        case 'Edit':
          this.toggleSupportQueryModal()
          break
        case 'Delete':
          this.toggleDeleteModel()
          break

        case 'CLOSE':
          this.toggleCloseSupportQueryModel()
          break
        case 'REOPEN':
          this.toggleReOpenSupportQueryModelShow()
          break
      }
    },

    setRightbarData(length = GENERAL_CONSTANTS.EMPTY_RECORD) {
      const rightBarContent = {
        header: {
          title: 'SUPPORT_QUERY',
          buttons: [
            {
              title: 'ADD_SUPPORT_QUERY',
              classes: ['primary-button-right'],
              action: {
                func: () => {
                  this.toggleSupportQueryModal()
                },
              },
            },
          ],
        },
        stats: [
          {
            title: GENERAL_CONSTANTS.STATS_AND_SUMMARY,
            categories: [{ text: 'TOTAL_QUERIES', value: length }],
          },
        ],
      }
      this.setRightbarContent(rightBarContent)
    },
    ...mapActions('layout', ['setRightbarContent', 'setShowModal']),
    ...mapActions('supportQuery', [
      'getsupportQueries',
      'deleteSupportQuery',
      'closeSupportQuery',
      'reOpenSupportQuery',
    ]),
  },
}
</script>
